import Vue from 'vue'
import register from '@/router/modules/register'
import login from '@/router/modules/login'
import forgotPassword from '@/router/modules/forgotPassword'
import VueRouter from 'vue-router'
import fraudPrevention from '@/views/landingPage/index.vue'

Vue.use(VueRouter)
const routes = [
  ...register,
  ...login,
  ...forgotPassword,
  {
    path: '/landingPage',
    name: 'landingPage',
    component: fraudPrevention
  },
  {
    path: '/',
    redirect: '/landingPage'
  }

]
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}
const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (['landingPage', 'Register', 'Login'].includes(to.name)) {
    return next()
  } else {
    next('/landingPage')
  }
  next()
})

router.afterEach((to, from) => {

})

export default router
